module.exports = __webpack_public_path__ + "static/media/belo-horizonte-mg.2360e5b7.jpg";